import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined'
import { Box, CircularProgress, MenuItem, Select, Typography } from '@mui/material'
import { useContext, useEffect, useMemo, useState } from 'react'
import { MentorClinicsContext } from 'src/mentor/layout'
import GoogleBusinessSettings from 'src/shared/googleBusiness/GoogleBusinessSettings'
import IntegrationsHub from 'src/shared/integrations/IntegrationsHub'
import { AvailabilityPageContainer } from '../MentorAvailabilityPage/MentorAvailabilityPageStyles'
import MentorHeader from '../MentorHeader'

// Owner-facing "Integrations" entry point for a clinic-owner practitioner. Sibling to the
// Business Model & Invoices page and reached from the mentor sidebar (gated on ROLE_CLINIC_OWNER).
// Extensible tile grid; today it holds a single tile (Google Business), whose full settings form
// — including the owner-only "Connect Google" OAuth flow — is the shared GoogleBusinessSettings
// component. This is the single home for Google Business config (previously a tab under Business
// Model & Invoices, now removed).
export default function MentorIntegrationsPage() {
  const { associatedClinicBrands, loadingAssociationsData } = useContext(MentorClinicsContext)

  const [selectedBrandId, setSelectedBrandId] = useState()

  useEffect(() => {
    if (!selectedBrandId && associatedClinicBrands?.length > 0) {
      setSelectedBrandId(associatedClinicBrands[0]?.id)
    }
  }, [associatedClinicBrands, selectedBrandId])

  const getBrandLabel = (brand) => brand?.brandName || brand?.title || brand?.id || ''

  const integrations = useMemo(() => {
    if (!selectedBrandId) return []
    return [
      {
        id: 'google-business',
        title: 'Google Business',
        description:
          'Set your clinic’s Google review link so practitioners can send patients a review request after a visit.',
        Icon: RateReviewOutlinedIcon,
        renderPanel: () => <GoogleBusinessSettings clinicBrandId={selectedBrandId} />,
      },
    ]
  }, [selectedBrandId])

  return (
    <AvailabilityPageContainer>
      <MentorHeader showBackButton heading="Integrations" />
      {loadingAssociationsData ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
          <CircularProgress />
        </Box>
      ) : !associatedClinicBrands?.length ? (
        <Typography sx={{ p: 3 }} color="text.secondary">
          No clinic brand is associated with your account yet.
        </Typography>
      ) : (
        <>
          {associatedClinicBrands.length > 1 && (
            <Box sx={{ px: 2, pt: 2 }}>
              <Select
                size="small"
                value={selectedBrandId || ''}
                onChange={(e) => setSelectedBrandId(e.target.value)}
              >
                {associatedClinicBrands.map((brand) => (
                  <MenuItem key={brand?.id} value={brand?.id}>
                    {getBrandLabel(brand)}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          )}
          {selectedBrandId && <IntegrationsHub integrations={integrations} />}
        </>
      )}
    </AvailabilityPageContainer>
  )
}
